export var EField;
(function (EField) {
    EField["Label"] = "epcLabel";
    EField["Value"] = "epcValue";
    EField["ExpirationDate"] = "epcExpirationDate";
    EField["CertificateId"] = "epcCertificateId";
})(EField || (EField = {}));
